module.exports = __webpack_public_path__ + "img/options-grinding.7d6c7155.svg";